<template>
  <v-btn
    v-if="$voicer.enabledComponent('wButtonLike')"
    v-bind="props"
    :disabled="informative"
    icon
    class="w-button-like"
    @click="handleLike"
  >
    <span v-if="mode === 'text'" v-text="hintText" />
    <v-icon :size="size" :color="color">
      {{ isReacted ? 'mdi-heart' : 'mdi-heart-outline' }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    isReacted: {
      type: Boolean,
      default: false,
    },
    informative: {
      type: Boolean,
      default: false,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: Number,
      default: 12,
    },
    mode: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    color() {
      const baseColor = 'grey lighten-1'
      const reactedColor = 'red lighten-2'

      return this.isReacted ? reactedColor : baseColor
    },
    hintText() {
      return this.$t(
        this.isReacted ? `cp_wbuttonlike_remove` : 'cp_wbuttonlike_add'
      )
    },
  },
  methods: {
    handleLike(e) {
      e.stopPropagation()

      this.isReacted ? this.$emit('unreact') : this.$emit('react')
    },
  },
}
</script>

<style lang="scss">
.w-button-like {
  align-self: inherit;

  .v-btn {
    position: relative;
    z-index: 1;
  }
}
</style>
